<script setup>
import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore, { Navigation } from "swiper";
import { ref, computed } from "vue";
import { trackSwiperEvents } from "@/analyticsHelper";

SwiperCore.use([Navigation]);

const knowledgebaseData = ref([]);

fetch("/api/collections/knowledgebase/entries").then((result) => {
    result.json().then((data) => {
        knowledgebaseData.value = data.data;
    });
});

const knowledgebaseChunks = computed(() => {
    const chunkSize = 4;
    const chunks = [];

    for (let i = 0; i < knowledgebaseData.value.length; i += chunkSize) {
        chunks.push(knowledgebaseData.value.slice(i, i + chunkSize));
    }

    return chunks;
});
</script>
<template>
    <swiper
        :loop="true"
        :slides-per-view="1"
        :navigation="{
            nextEl: '.slider-next',
            prevEl: '.slider-prev',
        }"
        data-slide-name="KNOWLEDGEBASE_BUTTONS"
        @swiper="trackSwiperEvents"
    >
        <swiper-slide v-for="(kbChunk, kbChunkIndex) in knowledgebaseChunks" :key="kbChunkIndex" class="self-start">
            <div class="grid grid-cols-1 gap-5">
                <a
                    v-for="(kbItem, kbItemIndex) in kbChunk"
                    :key="kbItemIndex"
                    :href="kbItem.url"
                    :title="kbItem.title"
                    class="group col-span-1 flex w-auto flex-shrink-0 items-center justify-between space-x-3 rounded-lg border border-gray-300 bg-white py-3 px-5 shadow-topanimation transition duration-300 ease-in-out hover:cursor-pointer lg:w-full xl:space-x-5 xl:py-5 xl:px-8"
                >
                    <div class="flex items-center space-x-5">
                        <i
                            class="fa-solid text-3xl text-teal transition duration-300 ease-in-out group-hover:text-orange"
                            :class="kbItem.knowledgebase_item_icon.value"
                        ></i>
                        <span class="text-left font-semibold lg:text-lg xl:text-xl" v-text="kbItem.title"></span>
                    </div>
                    <i class="fa-long-arrow-right fa-light text-3xl"></i>
                </a>
            </div>
        </swiper-slide>
        <div class="mt-6 flex flex-row justify-end space-x-3">
            <button
                class="slider-prev h-12 w-10 flex-shrink-0 rounded-lg border-2 border-orange hover:text-orange focus:ring-2 focus:ring-teal-600 active:ring-2 active:ring-teal-600"
            >
                <i class="fa-regular fa-chevron-left text-2xl"></i>
            </button>
            <button
                class="slider-next h-12 w-10 flex-shrink-0 rounded-lg border-2 border-orange hover:text-orange focus:ring-2 focus:ring-teal-600 active:ring-2 active:ring-teal-600"
            >
                <i class="fa-regular fa-chevron-right text-2xl"></i>
            </button>
        </div>
    </swiper>
</template>
